import type { DateRangePickerProps } from '@cloudscape-design/components/date-range-picker';
import type { ReportSearch, ReportSummary } from '../api';

export interface ReportsSearchState {
  queryText: string;
  searchContent: boolean;
  dateRange: DateRangePickerProps.Value | null;
  active?: ReportSearch;
}

export interface ReportsListSnapshot {
  pages: ReportSummary[][];
  pageCursors: (string | undefined)[];
  frontierHasNext: boolean;
  currentPageIndex: number;
  selectedScope?: string;
  availableScopes: string[];
  searchState?: ReportsSearchState;
  lastRefreshed?: string;
}

let snapshot: ReportsListSnapshot | null = null;

export function saveReportsList(next: ReportsListSnapshot): void {
  snapshot = next;
}

export function getReportsList(): ReportsListSnapshot | null {
  return snapshot;
}

/** Clears the cached list. Exposed primarily for test isolation. */
export function clearReportsList(): void {
  snapshot = null;
}
